import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';
import { HttpClient} from '@angular/common/http'
import { MatDialog,MatDialogConfig} from '@angular/material';

import { ApiService } from '../api.service';
import { Country,Event,EventYacht,EventCrew,EventClass, PaymentMethodType } from "../database";  // Classi per ogni tabella database

import { TranslateService } from '../translate.service';
import { DialogComponent } from '../dialog/dialog.component';


@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.css']
})
export class EntryComponent implements OnInit {

  isScreenLarge : boolean;
  // isStepperLinear = true;

  // Dati da tabelle database
  countries: Country[];
  eventyacht: EventYacht;
  eventcrews: EventCrew[];
  eventclasses: EventClass[];
  events: Event[];
  paymentmethodtype: PaymentMethodType[];
  eventClassFee: string;

  // I FormControl sono raggruppati in FormGroup (uno per ogni step)
  // e aggiunti ad un FormArray per aiutare l'elaborazione.
  formArray1: FormArray;
  formGroup1: FormGroup;
  formGroup2: FormGroup;
  formGroup3: FormGroup;
  formGroup4: FormGroup;
  formGroup5: FormGroup;  

  crewColumnsToDisplay: string[] = ['name', 'surname', 'birthdate','fivlic','country','email','actions'];

  uploadFilePath : string;
  uploadFile : File = null; 
  
  imageFilename : string;
  certFilename : string;
  certFilenameHasBeenChanged : boolean;
  certStatus: number;
  insuranceFilename : string;
  insuranceStatus : number;
  advertisementFilename : string;
  
  certificateImportFailedNoData: boolean;
  certificateImportFailedDuplicate: boolean;
  crewLicenceRequired: boolean;
  crewLicenceCheckFailed: boolean;
  crewNameDuplicateFailed: boolean;
  crewLicenceNameCheckFailed:boolean;
  crewLicenceName:string;


  selectedPaymentMethodType: number;
  
  constructor(private router: Router, 
              private formBuilder: FormBuilder, 
              public breakpointObserver: BreakpointObserver,
              private http: HttpClient, 
              private dialog: MatDialog,
              public api:ApiService,
              public translate: TranslateService) { }

  ngOnInit() {
    
    // console.log("EntryComponent.this.api.id_user = "+this.api.id_user);
    // console.log("EntryComponent.this.api.id_eventyacht = "+this.api.id_eventyacht);
    // console.log("EntryComponent.this.api.id_event = "+this.api.id_event);
    this.openDialog();

    // Variabili locali per gestione visualizzazione allegati
    this.imageFilename = "";
    
    this.insuranceFilename = "";
    this.insuranceStatus = 100;   // Default bloccato da amministrazione    
    this.certFilename = "";
    this.certFilenameHasBeenChanged = false;
    this.certStatus = 100;  // Default bloccato da amministrazione
    this.eventClassFee = "";  // Importo da pagare in base alla classe


    this.advertisementFilename = "";
    this.certificateImportFailedNoData = false;
    this.certificateImportFailedDuplicate = false;
    this.crewLicenceRequired = false;
    this.crewLicenceCheckFailed = false;
    this.crewNameDuplicateFailed = false;
    this.crewLicenceNameCheckFailed = false;
    this.crewLicenceName = "";
    
    this.countries = [];
    this.eventcrews = [];
    this.eventclasses = [];
    this.events=[];
    
    // Registro observable per cambio layout
    this.isScreenLarge = false;
    this.breakpointObserver.observe(['(min-width: 720px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        console.log('EntryComponent :: Viewport is 720px or over!');
        this.isScreenLarge = true;
      }
      else {
        console.log('EntryComponent :: Viewport is getting smaller than 720px !');
        this.isScreenLarge = false;
      }
    })

    // Questa funzione choiama le api di lettura Forms da database !
    this.createForms();   // Crea i form applicazione
    this.reloadForms();   // Rilegge i form dal database con api

  } 

  createForms(){
    // Creazione oggetti per la gestione reactive Forms
    // ATTENZIONE, event_name non è utilizzabile come FormControl perchè non è un campo di lookup, non esiste nella tabella
    this.formGroup1 = this.formBuilder.group({
      id_class: new FormControl('',[Validators.required])
    });
    
    // Armatore
    this.formGroup2 = this.formBuilder.group({
      owner_name: ['', [Validators.required,Validators.minLength(3),Validators.maxLength(12)]], // Test Validators multipli
      owner_surname: ['', Validators.required],
      owner_company: [''],
      owner_addrs1: [''],
      owner_cap: [''],
      owner_city: [''],
      owner_id_country: [''],
      owner_tel1: [''],
      owner_mobile: ['', Validators.required],
      owner_email: ['', Validators.email],
      owner_club_name: [''],
      mooring: [''],
    });

    // Imbarcazione
    this.formGroup3 = this.formBuilder.group({
      name: ['', Validators.required],
      sailn: ['', Validators.required],
      type: [''],
      loa: ['', Validators.required],
      bmax: ['', Validators.required],
      draft: ['', Validators.required],
      gph: [''],
      tcc: [''],
      cert_type: [''],
      // cert_date: [''],
      // cert_status: [''],
      cert_filename: [''],
      insurance_filename: [''],
      insurance_status: [''],
      advertisement_filename: [''],
      image_filename: [''],
    }); 
    
    // Pagamento e conferma
    this.formGroup4 = this.formBuilder.group({
      id_payment_method: ['', Validators.required],
      id_payment_status: [''],
      payment_user_note: [''],
    }); 

    // Equipaggio
    this.formGroup5 = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      birthdate: [''],
      fivlic: [''], // Parto come non richiesta, la cambio in tempo reale a richiesta per Italiani e Francesi
      email: [''],
      id_country: ['', Validators.required],
    }); 

    
    // ATTENZIONE Non aggiungo formGroup5 perchè è dedicato al solo inserimento equipaggio
    // Non è un form relativo all'iscrizione, viene usato solo localmente creando on-the-fly i dati per api.
    // Se lo aggiungi a formArray1 purtroppo viene elaborato come dati iscrizione ed alcuni campi non esistono.
    this.formArray1 = new FormArray([]);
    this.formArray1.push(this.formGroup1);
    this.formArray1.push(this.formGroup2);
    this.formArray1.push(this.formGroup3);
    this.formArray1.push(this.formGroup4);
    // this.formArray1.push(this.formGroup5); // NO !

}

setFormsDefault(){
    // Imposta i valori del form leggendoli dall'iscrizione
    this.formGroup1.controls['id_class'].setValue(this.eventyacht.id_class);

    this.formGroup2.controls['owner_name'].setValue(this.eventyacht.owner_name);
    this.formGroup2.controls['owner_surname'].setValue(this.eventyacht.owner_surname);
    // this.formGroup2.controls['owner_company'].setValue(this.eventyacht.owner_company);
    this.formGroup2.controls['owner_addrs1'].setValue(this.eventyacht.owner_addrs1);
    this.formGroup2.controls['owner_cap'].setValue(this.eventyacht.owner_cap);
    this.formGroup2.controls['owner_city'].setValue(this.eventyacht.owner_city);
    this.formGroup2.controls['owner_id_country'].setValue(this.eventyacht.owner_id_country);
    this.formGroup2.controls['owner_tel1'].setValue(this.eventyacht.owner_tel1);
    this.formGroup2.controls['owner_mobile'].setValue(this.eventyacht.owner_mobile);
    this.formGroup2.controls['owner_email'].setValue(this.eventyacht.owner_email);
    this.formGroup2.controls['owner_club_name'].setValue(this.eventyacht.owner_club_name);
    this.formGroup2.controls['mooring'].setValue(this.eventyacht.mooring);

    this.formGroup3.controls['name'].setValue(this.eventyacht.name);
    this.formGroup3.controls['sailn'].setValue(this.eventyacht.sailn);
    this.formGroup3.controls['type'].setValue(this.eventyacht.type);
    this.formGroup3.controls['loa'].setValue(this.eventyacht.loa);
    this.formGroup3.controls['loa'].setValue(this.eventyacht.loa);
    this.formGroup3.controls['bmax'].setValue(this.eventyacht.bmax);
    this.formGroup3.controls['draft'].setValue(this.eventyacht.draft);
    this.formGroup3.controls['gph'].setValue(this.eventyacht.gph);
    this.formGroup3.controls['tcc'].setValue(this.eventyacht.tcc);
    // Aggiorno le variabili di percorso documenti che servono rendere visibili o meno
    // i pulsanti di visualizzazione documenti    
    this.formGroup3.controls['image_filename'].setValue(this.eventyacht.image_filename); 
    if (this.eventyacht.image_filename !="")
      this.imageFilename = "allegati/"+ this.eventyacht.image_filename;
    else  
      this.imageFilename = "";
    this.formGroup3.controls['cert_filename'].setValue(this.eventyacht.cert_filename); 
    if (this.eventyacht.cert_filename !="")
      this.certFilename = "allegati/"+ this.eventyacht.cert_filename;
    else  
      this.certFilename = "";
    this.formGroup3.controls['insurance_filename'].setValue(this.eventyacht.insurance_filename); 
    if (this.eventyacht.insurance_filename !="")
      this.insuranceFilename = "allegati/"+ this.eventyacht.insurance_filename;
    else
      this.insuranceFilename = "";
    this.formGroup3.controls['advertisement_filename'].setValue(this.eventyacht.advertisement_filename);
    if (this.eventyacht.advertisement_filename !="")
      this.advertisementFilename = "allegati/"+ this.eventyacht.advertisement_filename;
    else
      this.advertisementFilename = "";

    this.selectedPaymentMethodType = this.eventyacht.id_payment_method;
    this.formGroup4.controls['id_payment_method'].setValue(this.eventyacht.id_payment_method);
    this.formGroup4.controls['payment_user_note'].setValue(this.eventyacht.payment_user_note); 
  
    
    // Aggiorno importo da pagare (sarebbe in)
    for (var i=0; i< this.eventclasses.length;i++) {
      if (this.eventclasses[i].id_class == this.eventyacht.id_class)
        this.eventClassFee = this.eventclasses[i].fee;
    }
    // console.log("this.eventClassFee="+this.eventClassFee);

  }

  checkAddEventCrew(){
    // Controllo licenza membro equipaggio da aggiungere
    // Questa funzione richiama addEventCrew() se l'esito controllo FIV/FFV è positivo
    // Utilizzo il WebWorker "FormData" per preparare ed inviare dati usando un Form leggibile dalla api PHP. 
    var licenceStatusActive = false;
    var duplicateName = false;

    // Scansione array membri equipaggio per ricerca duplicati
    for (var i=0;i<this.eventcrews.length;i++)
    {
      if ((this.eventcrews[i].name.toUpperCase()==this.formGroup5.controls['name'].value.toUpperCase())&&
          (this.eventcrews[i].surname.toUpperCase()==this.formGroup5.controls['surname'].value.toUpperCase())) {
        duplicateName=true;
      }
    }                        

    // Se trovo duplicato non proseguo e imposto variabile errore per template
    // se invece non è duplicato proseguo con il test eventuale tessera FIV/FFV
    if (duplicateName==true)
    {
      this.crewNameDuplicateFailed = true;
      this.crewLicenceNameCheckFailed = false;
      this.crewLicenceName = "";
    }
    else
    {
      this.crewNameDuplicateFailed = false; 

      // Solo per membri italiani e francesi controllo tessera FIV/FFV
      // Membro equipaggio Italiano
      console.log("checkAddEventCrew");
      
      // if (this.formGroup5.controls['id_country'].value=="105") {
      if (false) {  // ATTENZIONE 24/02/2021 Commento controllo FIV !!!!! Non esiste più il servizio!!
        this.openDialog();
        const fd = new FormData();
        fd.append('licenceType','FIV');
        fd.append('licenceNumber',this.formGroup5.controls['fivlic'].value);
        this.http.post('api/licence.php',fd).subscribe((data: any) => {
          if (data['active'])
          {
            if ((data['name'].toUpperCase()==this.formGroup5.controls['name'].value.toUpperCase()) &&
                (data['surname'].toUpperCase()==this.formGroup5.controls['surname'].value.toUpperCase())){
                // Reset tutti gli errori e aggiungo memnro equipaggio
                this.crewLicenceCheckFailed = false;
                this.crewLicenceNameCheckFailed = false;
                this.crewLicenceName = "";
                this.addEventCrew();
            }
            else
            {
              this.crewLicenceCheckFailed = false;
              this.crewLicenceNameCheckFailed = true;
              this.crewLicenceName = data['name'] + " " + data['surname'];
              this.dialog.closeAll();
            }
          }
          else
          {
            this.crewLicenceCheckFailed = true;
            this.crewLicenceNameCheckFailed = false;
            this.crewLicenceName = "";
            this.dialog.closeAll();
          }
        });  
      } 
      // 12/05/2025 Commento controllo iscrizione equipaggio francese su richiesta Frulloni
      else if (false) {
      // else if (this.formGroup5.controls['id_country'].value=="73") {
        // Membro equipaggio Francese
        this.openDialog();
        const fd = new FormData();
        fd.append('licenceType','FFV');
        fd.append('licenceNumber',this.formGroup5.controls['fivlic'].value);
        this.http.post('api/licence.php',fd).subscribe((data: any) => {
          // Aggiorno variabile form e variabile percorso usata in html
          if (data['active'])
          {
            if ((data['name'].toUpperCase()==this.formGroup5.controls['name'].value.toUpperCase()) &&
              (data['surname'].toUpperCase()==this.formGroup5.controls['surname'].value.toUpperCase())){
              // Reset tutti gli errori e aggiungo memnro equipaggio
              this.crewLicenceCheckFailed = false;
              this.crewLicenceNameCheckFailed = false;
              this.crewLicenceName = "";
              this.addEventCrew();
            }
            else
            {
              this.crewLicenceCheckFailed = false;
              this.crewLicenceNameCheckFailed = true;
              this.crewLicenceName = data['name'] + " " + data['surname'];
              this.dialog.closeAll();
            }            
          }
          else
          {
            this.crewLicenceCheckFailed = true;
            this.crewLicenceNameCheckFailed = false;
            this.crewLicenceName = "";
            this.dialog.closeAll();
          }
        });  
      }
      else
      {
        this.openDialog();
        this.crewLicenceCheckFailed = false;
        this.addEventCrew();  // Membro paese non soggetto a controllo tessera, iscrizio senza condizione
      }  
    }  
  }

  addEventCrew(){
    console.log("addEventCrew::this.formGroup5.controls['name']=" + this.formGroup5.controls['name'].value);
    // Aggiunge membro equipaggio
    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "eventcrews",
      "action": "POST",
      "offset": 0,
      "limit": 0,
      "filters": [],
      "order": "",
      "data": {
               'id_eventyacht': this.api.id_eventyacht,
               'id_user': this.api.id_user,
               'name': this.formGroup5.controls['name'].value,
               'surname': this.formGroup5.controls['surname'].value,
               'birthdate': this.formGroup5.controls['birthdate'].value,
               'email': this.formGroup5.controls['email'].value,
               'fivlic': this.formGroup5.controls['fivlic'].value,
               'id_country': this.formGroup5.controls['id_country'].value
              }

    }).subscribe((data: any[]) => {
      
      if (data.toString()=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      // Attenzione, la chiamata è asincrona...
      console.log("addEventCrew::api reply = " + data);
      this.reloadForms();
      // ATTENZIONE, this.dialog.closeAll() sarà chiamato dentro reloadForms!
    });    
  }

  removeEventCrew(id_eventcrew:number){
    // Rimuove membro equipaggio
    // console.log("removeEventCrew::id_eventcrew="+id_eventcrew);
    this.openDialog();

    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "eventcrews",
      "action": "DELETE",
      "offset": 0,
      "limit": 1,
      "filters": ["id_eventcrew=" + id_eventcrew],
      "order": "",
      "data": {}
    }).subscribe((data: any[]) => {
      
      if (data.toString()=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      console.log("removeEventCrew::api reply = " + data);
      this.reloadForms();

    });        
  }

  stepperChange(event){
    // console.log(event);
    // ATTENZIONE, decido di resettare gli errori "manuali" dei form quyando cambio stepper
    this.certificateImportFailedNoData = false;
    this.certificateImportFailedDuplicate = false;
    this.crewLicenceCheckFailed = false;
    this.crewNameDuplicateFailed = false;
  }

  onImageFileSelected(event){

    this.openDialog();
   
    console.log("onImageFileSelected");
    // Utilizzo il WebWorker "FormData" per preparare ed inviare dati usando un Form leggibile dalla api PHP. 
    this.uploadFile = <File> event.target.files[0];
    const fd = new FormData();
    fd.append('uploadAction','image');
    fd.append('id_user',this.api.id_user.toString());
    fd.append('id_event',this.api.id_event.toString());
    fd.append('id_eventyacht',this.api.id_eventyacht.toString());
    fd.append('uploadFile',this.uploadFile,this.uploadFile.name); 
    this.http.post('api/upload.php',fd).subscribe(res=>{
      // Aggiorno variabile form e variabile percorso usata in html
      // ATTENZIONE Si sono verificate iscrizioni dove "image_filename" valeva AUTH_ERROR !
      // Eseguo un controllo in caso di errore autenticazione
      if (res=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      else
      {
        this.formGroup3.controls['image_filename'].setValue(res);
        this.imageFilename = "allegati/" + this.formGroup3.controls['image_filename'].value + "?"+Math.random();
        console.log("this.imageFilename="+this.imageFilename);
      }  
      this.dialog.closeAll();
    });  
  }

  onCertificateFileSelected(event){
    console.log(event);
    this.openDialog();

    // Utilizzo il WebWorker "FormData" per preparare ed inviare dati usando un Form leggibile dalla api PHP. 
    this.uploadFile = <File> event.target.files[0];
    const fd = new FormData();
    fd.append('uploadAction','certificate');
    fd.append('id_user',this.api.id_user.toString());
    fd.append('id_event',this.api.id_event.toString());
    fd.append('id_eventyacht',this.api.id_eventyacht.toString());
    fd.append('uploadFile',this.uploadFile,this.uploadFile.name); 
    this.http.post('api/upload.php',fd).subscribe(res=>{
      // Eseguo un controllo in caso di errore autenticazione
      if (res=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      else
      {
        // Aggiorno variabile form e variabile percorso usata in html
        this.formGroup3.controls['cert_filename'].setValue(res);
        this.certFilename = "allegati/" + this.formGroup3.controls['cert_filename'].value;
        console.log("this.certFilename="+this.certFilename);
        this.dialog.closeAll();
        // Invio email di allerta per modifica certificato solo se l'iscrizione era già esistente
        // ed era già presente un file certificato caricato !
        if ((this.api.id_eventyacht>0)&&(this.eventyacht.cert_filename!=""))
        {
          console.log("this.api.id_eventyacht="+this.api.id_eventyacht.toString());
          const fd = new FormData();
          fd.append('SendUpdateCertificateMail',this.api.id_eventyacht.toString());
          this.http.post('api/sendmail.php',fd).subscribe((data: any) => {
              console.log(data);
              this.dialog.closeAll();
          });
        }
      }
    });  
  }

  onInsuranceFileSelected(event){

    this.openDialog();    
    console.log(event);
    
    // Utilizzo il WebWorker "FormData" per preparare ed inviare dati usando un Form leggibile dalla api PHP. 
    this.uploadFile = <File> event.target.files[0];
    const fd = new FormData();
    fd.append('uploadAction','insurance');
    fd.append('id_user',this.api.id_user.toString());
    fd.append('id_event',this.api.id_event.toString());
    fd.append('id_eventyacht',this.api.id_eventyacht.toString());
    fd.append('uploadFile',this.uploadFile,this.uploadFile.name); 
    this.http.post('api/upload.php',fd).subscribe(res=>{
      console.log(res);
      if (res=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      else
      {

        this.formGroup3.controls['insurance_filename'].setValue(res);
        this.insuranceFilename = "allegati/" + this.formGroup3.controls['insurance_filename'].value;
        console.log("this.insuranceFilename="+this.insuranceFilename);
        // Invio email di allerta per modifica assicurazione solo se l'iscrizione era già esistente
        // ed era già presente un file certificato caricato !
        if ((this.api.id_eventyacht>0)&&(this.eventyacht.insurance_filename!=""))
        {
          const fd = new FormData();
          fd.append('SendUpdateInsuranceMail',this.api.id_eventyacht.toString());
          this.http.post('api/sendmail.php',fd).subscribe((data: any) => {
              console.log(data);
          });
        }
        this.dialog.closeAll();
      }  
    });  
  }

  onAdvertisementFileSelected(event){
    this.openDialog();
    console.log(event);
    // Utilizzo il WebWorker "FormData" per preparare ed inviare dati usando un Form leggibile dalla api PHP. 
    this.uploadFile = <File> event.target.files[0];
    const fd = new FormData();
    fd.append('uploadAction','advertisement');
    fd.append('id_user',this.api.id_user.toString());
    fd.append('id_event',this.api.id_event.toString());
    fd.append('id_eventyacht',this.api.id_eventyacht.toString());
    fd.append('uploadFile',this.uploadFile,this.uploadFile.name); 
    this.http.post('api/upload.php',fd).subscribe(res=>{
      if (res=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      else
      {
      
        this.formGroup3.controls['advertisement_filename'].setValue(res);
        this.advertisementFilename = "allegati/" + this.formGroup3.controls['advertisement_filename'].value;
        console.log("this.advertisementFilename="+this.advertisementFilename);
      }  
      this.dialog.closeAll();
    });  
  }

  loadDataFromCertificate(certificateType:string) {
    // Ricopia i dati imbarcazione letti nel database certificati, filtrando i certificati IRC e cercando
    // il numero velico imbarcazione scritto nel Form.
    // non posso usare nome imbarcazione, esistono duplicati
    var sailn = this.formGroup3.controls['sailn'].value;
    var boat_name = this.formGroup3.controls['name'].value;
    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "certificates",
      "action": "GET",
      "offset": 0,
      "limit": 0,
      "filters": ["sailn='" + sailn + "'","type='"+certificateType+"'"],
      "order": "",
      "data": []
    }).subscribe((dataCertificates: any[]) => {
      
      if (dataCertificates.toString()=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }

      console.log(dataCertificates['data']);
      if (dataCertificates['data'].length == 1)
      {
        this.formGroup3.controls['name'].setValue(dataCertificates['data'][0]['boat_name']);
        this.formGroup3.controls['type'].setValue(dataCertificates['data'][0]['boat_type']);
        this.formGroup3.controls['loa'].setValue(dataCertificates['data'][0]['loa']);
        this.formGroup3.controls['bmax'].setValue(dataCertificates['data'][0]['bmax']);
        this.formGroup3.controls['draft'].setValue(dataCertificates['data'][0]['draft']);
        this.formGroup3.controls['gph'].setValue(dataCertificates['data'][0]['gph']);
        this.formGroup3.controls['tcc'].setValue(dataCertificates['data'][0]['tcc']);
        this.certificateImportFailedNoData = false;
        this.certificateImportFailedDuplicate = false;
      }
      else if (dataCertificates['data'].length == 0)
      {
        this.certificateImportFailedNoData = true;
        this.certificateImportFailedDuplicate = false;
        console.log ("loadDataFromCertificate:: no certificate found !");
      }  
      else if (dataCertificates['data'].length > 1)
      {
        this.certificateImportFailedNoData = false;
        this.certificateImportFailedDuplicate = true;
        console.log ("loadDataFromCertificate:: certificate is duplicate !");
      }  

    });    
  }

  saveNewEventyacht(){
    // Salvo i dati Form in una nuova iscrizione

    // ATTENZIONE Correzione formattazione numerica errata prima di salvare
    // Non esistono Validator standard semplici, dovrei creare custom e comunque l'effetto per l'utente è difficile da capire
    this.formGroup3.controls['loa'].setValue(this.formGroup3.controls.loa.value.toString().replace(",","."));
    this.formGroup3.controls['bmax'].setValue(this.formGroup3.controls.bmax.value.toString().replace(",","."));
    this.formGroup3.controls['draft'].setValue(this.formGroup3.controls.draft.value.toString().replace(",","."));
    this.formGroup3.controls['tcc'].setValue(this.formGroup3.controls.tcc.value.toString().replace(",","."));
    this.formGroup3.controls['gph'].setValue(this.formGroup3.controls.gph.value.toString().replace(",","."));

    // Costruisco oggetto contenente coppie chiave/valore per tutti i FormControl
    // non nulli contenuti nel FormArray passato a parametro
    var data = this.api.formArrayToApiData(this.formArray1);
    
    // Aggiungo eventuali altri campi non presenti nel FormControl
    data['id_event'] = this.api.id_event;
    data['id_user'] = this.api.id_user;
    data['id_status'] = 100;  // ATTENZIONE!!! Necessario, se lascio 0 il software iscrizioni la cancella al prossimo login
    
    // Aggiunge nuova iscrizione con chiamata api post
    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "eventyachts",
      "action": "POST",
      "offset": 0,
      "limit": 0,
      "filters": [],
      "order": "",
      "data": data
    }).subscribe((data: any[]) => {
      
      if (data.toString()=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      else
      {
        // console.log("saveNewEventyacht::api reply = " + data);
        // Rinomimo e salvo i file temporanei immagine, certificato, assicurazione e pubblicità
        const fd = new FormData();
        fd.append('uploadAction','savetmpfiles');
        fd.append('id_user',this.api.id_user.toString());
        fd.append('id_event',this.api.id_event.toString());
        // ATTENZIONE, forse sarebbe più sicuro aggiungere anche id_class....
        fd.append('id_eventyacht','0');
        this.http.post('api/upload.php',fd).subscribe(res=>{
          console.log("saveNewEventyacht::uploadAction=savetmpfiles / res= "+res);
          // this.reloadForms();
          // Rileggo i dati iscrizione per permettere di proseguire con equipaggio
          this.api.call({
            "id": "",
            "auth": this.api.authData.sid,
            "resource": "eventyachts",
            "action": "GET",
            "offset": 0,
            "limit": 0,
            "filters": ["id_user=" + this.api.id_user,"id_event="+this.api.id_event],
            "order": "",
            "data": []
          }).subscribe((data: any[]) => {
          
            // console.log("Rilettura iscrizione dopo salvataggio completata");      
            // console.log(data['data']);      
            
            // Assegno nuovo numero iscrizione !
            this.api.id_eventyacht = data['data'][0].id_eventyacht;
            this.eventyacht = data['data'][0];

            // Devo aggiornare i nomi immagini, potrebbero essere ancora i nomi temporanei se prima iscrizione!
            this.formGroup3.controls['image_filename'].setValue(this.eventyacht.image_filename); 
            if (this.eventyacht.image_filename !="")
              this.imageFilename = "allegati/"+ this.eventyacht.image_filename;
            else  
              this.imageFilename = "";
            this.formGroup3.controls['cert_filename'].setValue(this.eventyacht.cert_filename); 
            if (this.eventyacht.cert_filename !="")
              this.certFilename = "allegati/"+ this.eventyacht.cert_filename;
            else  
              this.certFilename = "";
            this.formGroup3.controls['insurance_filename'].setValue(this.eventyacht.insurance_filename); 
            if (this.eventyacht.insurance_filename !="")
              this.insuranceFilename = "allegati/"+ this.eventyacht.insurance_filename;
            else
              this.insuranceFilename = "";
            this.formGroup3.controls['advertisement_filename'].setValue(this.eventyacht.advertisement_filename);
            if (this.eventyacht.advertisement_filename !="")
              this.advertisementFilename = "allegati/"+ this.eventyacht.advertisement_filename;
            else
              this.advertisementFilename = "";

            // console.log("Nuova this.api.id_eventyacht= " + this.api.id_eventyacht);
            // console.log("this.eventyacht.id_eventyacht= " + this.eventyacht.id_eventyacht);
            // console.log("this.eventyacht.id_class= " + this.eventyacht.id_class);

            // Invio email conferma nuova iscrizione
            const fd = new FormData();
            fd.append('SendNewEntryStatusMail',this.api.id_eventyacht.toString());
            this.http.post('api/sendmail.php',fd).subscribe((data: any) => {
                console.log(data);
            }); // sendmail
          }); // reload
      }); //upload
    } // AUTH error

      // this.api.id_eventyacht = -1;
      // this.router.navigate(['/events']);
    }); // POST
  }  

  saveUpdatedEventyacht(){
    // Aggiorno l'iscrizione esistente con i dati del Form

    // ATTENZIONE Correzione formattazione numerica errata prima di salvare
    // Non esistono Validator standard semplici, dovrei creare custom e comunque l'effetto per l'utente è difficile da capire
    this.formGroup3.controls['loa'].setValue(this.formGroup3.controls.loa.value.toString().replace(",","."));
    this.formGroup3.controls['bmax'].setValue(this.formGroup3.controls.bmax.value.toString().replace(",","."));
    this.formGroup3.controls['draft'].setValue(this.formGroup3.controls.draft.value.toString().replace(",","."));
    this.formGroup3.controls['tcc'].setValue(this.formGroup3.controls.tcc.value.toString().replace(",","."));
    this.formGroup3.controls['gph'].setValue(this.formGroup3.controls.gph.value.toString().replace(",","."));

    // Costruisco oggetto contenente coppie chiave/valore per tutti i FormControl
    // non nulli contenuti nel FormArray passato a parametro
    // console.log("saveUpdatedEventyacht::this.api.id_eventyacht="+this.api.id_eventyacht)
    // var data = this.formArrayToApiData(this.formArray1);
    var data = this.api.formArrayToApiData(this.formArray1);
    

    // Non sono presenti altri  altri campi da aggiungere a "data" come avviene nel caso di nuova iscrizione
    // Aggiunge nuova iscrizione con chiama api post
    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "eventyachts",
      "action": "UPDATE",
      "offset": 0,
      "limit": 0,
      "filters": ["id_eventyacht=" + this.api.id_eventyacht],
      "order": "",
      "data": data
    }).subscribe((data: any[]) => {
      // console.log("saveUpdatedEventyacht::api reply = " + data);
      if (data.toString()=="AUTH_ERROR")
      {
        this.dialog.closeAll();
        this.api.logout();
        this.router.navigate(['/login']);
      }
      this.api.id_eventyacht = -1;
      this.router.navigate(['/events']);
    });    
    
  }  

  stepperCancelClose(){
    // TODO ATTENZIONE questo evento di chiusura causa warning console "Form submission canceled because the form is not connected"
    this.api.id_eventyacht = -1;  // -1 Nessuna iscrizione, 0=Nuova iscrizione non salvata, >0 Iscrizione in modifica
    this.router.navigate(['/events']); 
  }

  viewDocument(name:string){
    // Questa funzione sembra necessaria perchè l'oggetto window sembra non definito nel template html
    // o meglio nell'evento (click) del template html
    window.open(name+ "?"+Math.random());
  }

  isRequired(data:any){
    // console.log("isRequired");
    console.log(data);
    return true;
  }

  reloadForms(){
    // Provo a mettere in unica funzione la rilettura forms da database
    // Le api sono asincrone, le metto tutte in cascata...
    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "countries",
      "action": "GET",
      "offset": 0,
      "limit": 0,
      "filters": [],
      "order": "",
      "data": []
    }).subscribe((dataCountries: any[]) => {
      // Attenzione, la chiamata è asincrona...
      this.countries = dataCountries['data'];
      // console.log("EventsComponents::api.php reply : " +  JSON.stringify(this.events));
      // console.log("N." + this.countries.length + " countries loaded")
      this.api.call({
        "id": "",
        "auth": this.api.authData.sid,
        "resource": "paymentmethodtype",
        "action": "GET",
        "offset": 0,
        "limit": 0,
        "filters": [],
        "order": "",
        "data": []
      }).subscribe((dataPaymentmethodtype: any[]) => {
        // Attenzione, la chiamata è asincrona...

        // Controllo eventuale risposta errore autorizzazione e provo a gestirla  
        // Potrebbe essere necessario per timoeut sessione ?
        if (dataPaymentmethodtype.toString()=="AUTH_ERROR")
        {
          this.dialog.closeAll();
          this.api.logout();
          this.router.navigate(['/login']);
        }
        else
        {
          this.paymentmethodtype = dataPaymentmethodtype['data'];
          // console.log("EventsComponents::api.php reply : " +  JSON.stringify(this.events));
          // console.log("N." + this.paymentmethodtype.length + " paymentmethodtype loaded")
          // Leggo evento
          this.api.call({
            "id": "",
            "auth": this.api.authData.sid,
            "resource": "events",
            "action": "GET",
            "offset": 0,
            "limit": 0,
            "filters": ["id_event=" + this.api.id_event],
            "order": "begin",
            "data": []
          }).subscribe((dataEvents: any[]) => {
            // Attenzione, la chiamata è asincrona...
            this.events = dataEvents['data'];
            // console.log("EventryComponent::api.php reply : " +  JSON.stringify(dataEvents['data']));
            console.log("N." + this.events.length + " events loaded")

            // Leggo classi associate all'evento
            this.api.call({
              "id": "",
              "auth": this.api.authData.sid,
              "resource": "eventclasses",
              "action": "GET",
              "offset": 0,
              "limit": 0,
              "filters": ["id_event=" + this.api.id_event],
              "order": "id_eventclass ASC",
              "data": []
            }).subscribe((dataEventClasses: any[]) => {
              // Deve esistere sempre almeno una classe 
              this.eventclasses = dataEventClasses['data'];
              // console.log("EntryComponent dopo lettura dataEventClasses['data'].length=" + dataEventClasses['data'].length);

              // Provo a cercare iscrizione per questo utente ed evento
              this.api.call({
                "id": "",
                "auth": this.api.authData.sid,
                "resource": "eventyachts",
                "action": "GET",
                "offset": 0,
                "limit": 0,
                "filters": ["id_event=" + this.api.id_event,"id_user="+this.api.id_user],
                "order": "id_eventyacht ASC",
                "data": []
              }).subscribe((dataEventyachts: any[]) => {
                // Se trovo iscrizione allora leggo i campi dati nei form
                if (dataEventyachts['data'].length>0)
                {
                  this.eventyacht = dataEventyachts['data'][0];
                  this.api.id_eventyacht = this.eventyacht.id_eventyacht;
                  this.certStatus = this.eventyacht.cert_status;
                  this.insuranceStatus = this.eventyacht.insurance_status;

                  // this.imageFilename="allegati/" + this.eventyacht.id_eventyacht + ".jpg";    
                  
                  // console.log("EntryComponent dopo lettura evento - this.api.id_eventyacht = " + this.api.id_eventyacht);
                  // console.log("EntryComponent dopo lettura evento - this.imageFilename = " + this.imageFilename);

                  this.api.call({
                    "id": "",
                    "auth": this.api.authData.sid,
                    "resource": "eventcrews",
                    "action": "GET",
                    "offset": 0,
                    "limit": 0,
                    "filters": ["id_eventyacht=" + this.api.id_eventyacht],
                    "order": "",
                    "data": []
                    }).subscribe((dataEventcrews: any[]) => {
                      // Attenzione, la chiamata è asincrona...
                      if (dataEventcrews['data'] != undefined)
                        this.eventcrews = dataEventcrews['data'];
                      console.log("N." + this.eventcrews.length + " eventcrews loaded");
                      
                      // Ho trovato iscrizione esistente da modificare, leggo i campi form
                      this.setFormsDefault(); 
                      this.dialog.closeAll();
  
                      // console.log("N." + dataEventcrews['data'].length + " dataEventcrews['data'] loaded");
                    }); // eventcrews
                }      
                else
                {
                  this.api.id_eventyacht = 0;
                  // this.certStatus = 100;
                  // this.insuranceStatus = 100;
                  this.certStatus = 0;
                  this.insuranceStatus = 0;
                  this.dialog.closeAll();
                  // this.formGroup1.controls['event_name'].setValue(this.events[0].name);
                }
              }); // eventyachts
            }); // eventclasses
          }); // events
        }; // AUTH_ERROR  
      }); // paymentmethodtype
    }); // countries

  }

  bnlPay(){
    // Pagamento BNL online
    // Utilizzo il WebWorker "FormData" per preparare ed inviare dati usando un Form leggibile dalla api PHP. 
    
    // ATTENZIONE Devo aprire una nuova pagina web nel browser per il pagamento che richiede variabili di sessione
    // Non posso chiamare la pagina con ajax e non posso aprire una finestra dentro codice di ritorno ajax
    // a casusa di un blocco di sicurezza del browser che permette apertura pagine solo con evento click diretto.
    // Devo quindi usare un trucco, aprire una pagina subito nell'evento di click e cambiare il riferimento 
    // successivamente nel codice di ritorno
    var bnlPayNewWindow = window.open();  

    const fd = new FormData();
    
    // Riduco dimensione nome evento per evitare limite non scritto a 100caratteri nel form BNL
    var bnlItemName = this.api.event_name;
    
    bnlItemName = bnlItemName.replace("ROLEX GIRAGLIA","RG");
    bnlItemName = bnlItemName.replace("GIRAGLIA ROLEX CUP","RG");
    
    bnlItemName = bnlItemName.substring(0,18);  // Limito il pagamento !!!
    bnlItemName = bnlItemName + " - " + this.formGroup3.controls['name'].value.substring(0,12);

    fd.append('bnl_item_number',this.api.id_eventyacht.toString());
    fd.append('bnl_item_name',bnlItemName);
    
    
    // TODO Non posso usare l'importo relativo all'evento ma devo cercare in 
    //fd.append('bnl_amount',this.events[0].fee);
    // ATTENZIONE, potrei utilizzare "this.eventClassFee" ma non lo faccio perchè
    // voglio ricalcolare usando l'ultimo dato del riletto dal database NON quello
    // del form. Un utente potrebbe cambiare il form, pagare ridotto e uscire  senza salvare
    var fee = "";
    for (var i=0; i< this.eventclasses.length;i++) {
      if (this.eventclasses[i].id_class == this.eventyacht.id_class)
        fee = this.eventclasses[i].fee;
    }
    console.log("bnl_amount="+fee);
    fd.append('bnl_amount',fee);
    fd.append('bnl_email',this.formGroup2.controls['owner_email'].value);

    // La chiamata POST serve solo per impostare le variabili di sessione
    // La pagina di pagamento con il codice BNL deve essere chiamata con window.open
    this.http.post('api/bnl_setup.php',fd).subscribe((data:any[])=>{
      console.log(data);
      // window.open('api/bnl_entry.php');
      // window.open('assets/Divisioni_in_Classi.pdf');
      // tabWindowId.location.href = "assets/Divisioni_in_Classi.pdf";
      bnlPayNewWindow.location.href = "api/bnl_entry.php";
    });  
  }
  
  changePaymentType(paymentMethodType){
    this.selectedPaymentMethodType = paymentMethodType;
  }

  changeClass(classId){
    // Recupero l'importo da pagare ma non lo uso !!!
    // Alla fine preferisco rileggere il valore importo basandomi sulla classe
    // riletta dal database e non dal form
    for (var i=0; i< this.eventclasses.length;i++) {
      if (this.eventclasses[i].id_class == classId)
        this.eventClassFee = this.eventclasses[i].fee;
    }
    // console.log("changeClass id=" + classId);
    // console.log("this.eventClassFee=" + this.eventClassFee);
  }

   openDialog(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(DialogComponent,dialogConfig);
      
    // setTimeout(()=>{this.dialog.closeAll();}, 3000);
   }  

   changeCrewCountry(event){
    // Quando cambio paese membro equipaggio verifico se Italia o Francia per abilitare richiesta FIV e FFV
    // crewLicenceRequired
    console.log(event);
   }
   
   checkCrewLicenceRequired(){
    if (this.formGroup5.controls['id_country'].value=="105" || this.formGroup5.controls['id_country'].value=="73")
      return true;
    else  
      return false;
   }
}
